import styled from 'styled-components';

export const Container = styled.div`
  width: 37rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  height: 100%;

  form {
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding-top: 1rem;
    margin-bottom: 2rem;

    > div:not(:first-child) {
      margin-top: 2rem;
    }
  }
`;

export const GroupButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
